<template>
  <div class="schedule_list">
    <div v-show="todayScheduleList.length === 0">
      <div class="noneDefaultItem">
        <div class="none_default_img_div">
          <img class="none_default_img" src="../../../static/img/scheduleDefault.png"/>
        </div>
        <div class="none_default_text">
          <div class="text_1">还没有日程</div>
          <div class="text_2">点击添加日程，创建日程</div>
        </div>
      </div>
    </div>
    <div v-for="schedule in todayScheduleList" :key="'noComplete' + schedule.task_no" v-show="schedule.status == 1">
      <div class="scheduleItem">
        <div class="checkBox" @click="upDateScheduleStatus(schedule.task_no)" v-if="schedule.user_no === userInfo.user_no">
          <img src="../../../static/img/noComplete.png">
        </div>
        <div class="checkBox" v-if="schedule.user_no !== userInfo.user_no"></div>
        <div class="content">
          <div class="title">{{schedule.title}}</div>
          <div class="remark" v-show="schedule.content !== ''">{{schedule.content}}</div>
          <div class="tag">
            <div class="creator">{{schedule.create_name}}</div>
            <div class="type">
              <span :style="{color : schedule.color}">•</span>
              <span>{{schedule.category_name}}</span>
            </div>
          </div>
        </div>
        <div class="opts" v-if="schedule.user_no !== userInfo.user_no"></div>
        <div class="opts" v-if="schedule.user_no === userInfo.user_no">
          <el-dropdown class="more_dropdown" trigger="click">
            <span class="el-dropdown-link more">
              <i class="el-icon-more"></i>
            </span>
            <el-dropdown-menu class="schedule_more_dropdown_menu" slot="dropdown">
              <el-dropdown-item><div @click="showEditScheduleDialog(schedule.task_no)"><i class="el-icon-edit-outline"></i>编辑</div></el-dropdown-item>
              <!--<split></split>-->
              <el-dropdown-item class="delete"><div @click="deleteSchedule(schedule.task_no)"><i class="el-icon-delete"></i>删除</div></el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
        </div>
      </div>
    </div>
    <template v-if="isExistNotComplete">
      <div class="title_complete">已完成</div>
      <div v-for="schedule in todayScheduleList" :key="'completed' + schedule.task_no" v-show="schedule.status == 2">
        <div class="scheduleItem">
          <div class="checkBox">
            <img src="../../../static/img/completed.png">
          </div>
          <div class="content">
            <div class="title">{{schedule.title}}</div>
            <div class="remark" v-show="schedule.content !== ''">{{schedule.content}}</div>
            <div class="tag">
              <div class="creator">{{schedule.create_name}}</div>
              <div class="type">
                <span :style="{color : schedule.color}">•</span>
                <span>{{schedule.category_name}}</span>
              </div>
            </div>
          </div>
          <div class="opts">
          </div>
        </div>
      </div>
    </template>
  </div>
</template>

<script type="text/ecmascript-6">
import { mapState } from 'vuex'
import axios from 'axios'
// import moment from 'moment'
import split from './split_line_1px.vue'
export default {
  components: {split},
  name: 'scheduleList',
  data: function () {
    return {
    }
  },
  computed: {
    ...mapState([
      'todayScheduleList',
      'selectDate',
      'userInfo'
    ]),
    isExistNotComplete: function () {
      let completeNum = 0
      this.todayScheduleList.forEach(schedule => {
        if (schedule.status === 2) {
          completeNum++
        }
      })
      return completeNum > 0
    }
  },
  methods: {
    showAddScheduleDialog () {
      this.$store.dispatch('setSelectDate', this.selectDate)
      let data = {
        visible: true,
        method: 'add',
        no: ''
      }
      this.$store.dispatch('setScheduleDialog', data)
    },
    showEditScheduleDialog (taskNo) {
      let data = {
        visible: true,
        method: 'edit',
        no: taskNo
      }
      this.$store.dispatch('setScheduleDialog', data)
    },
    deleteSchedule (taskNo) {
      let _this = this
      axios({
        url: _this.HOST + '/task/deleteTask',
        method: 'post',
        params: {
          update_user: _this.$store.state.userInfo.user_no,
          task_no: taskNo
        }
      }).then((res) => {
        let data = res.data
        console.log('删除日程')
        console.log(data)
        if (data.statusCode === 200) {
          this.$store.dispatch('setTodayScheduleList', data)
          this.$store.dispatch('setCalanderRefresh', true)
        } else {
          console.log(data.message)
        }
      }).catch((err) => {
        console.log(err)
      })
    },
    upDateScheduleStatus (taskNo) {
      let _this = this
      axios({
        method: 'post',
        url: _this.HOST + '/task/updateTask',
        params: {
          update_user: _this.$store.state.userInfo.user_no,
          task_no: taskNo,
          status: 2
        }
      }).then(function (response) {
        let data = response.data
        console.log('修改成功')
        console.log(data)
        if (data.statusCode === 200) {
          _this.$store.dispatch('setTodayScheduleList')
        } else {
          console.log(data.message)
        }
      }).catch(function (error) {
        console.log(error)
      })
    }
  }
}
</script>

<style lang="stylus">
  .schedule_more_dropdown_menu.el-dropdown-menu--medium
    padding 0 !important
    width 5.625rem
    .el-dropdown-menu__item
      padding 0 !important
      div
        padding 0 1.0625rem
    li:hover
      color $lightGrey !important
      background-color $bgGray !important
    li
      padding 0 !important
      height 2rem
      line-height 2rem
      color $tinGrey
      font-size 14px
      text-align left
      i
        margin-right 0.625rem
    .delete
      color $darkRed
    .invite_new_member
      color $elemBlue
    .split_line_1px
      width 80%
      margin-left 10%
  .schedule_list
    height 98%
    overflow-y auto
    .title_complete
      height 2.5rem
      line-height 2.5rem
      padding-left 1.25rem
      border-bottom 0.0625rem solid $tinGrey
    .noneDefaultItem
      padding 1.5rem 0
      text-align center
      .none_default_img_div
        display inline-block
        vertical-align top
        margin-right 20px
        .none_default_img
          height 47px
          width 57px
      .none_default_text
        display inline-block
        vertical-align top
        text-align left
        .text_1
          color $pepperGrey
          font-size 14px
        .text_2
          margin-top 8px
          color $lightGrey
          font-size 12px
    .scheduleItem
      min-height 2.5625rem
      padding 0.7rem 0rem 0.7rem 1.25rem
      background $white
      border-bottom 0.0625rem solid $tinGrey
      display flex
      .icon-add2
        color $elemBlue
        text-align center
        font-size 2rem
        cursor pointer
      .add_text
        padding-top 0.25rem
        text-align center
      .checkBox
        flex 1
        margin-right 0.25rem
        padding-top 0.125rem
        img
          width 1rem
          height 1rem
      .opts
        flex 2
        text-align center
        font-size 0.875rem
        .more_dropdown
          cursor pointer
          color $tinGrey
        .more_dropdown:hover
          color $elemBlue
      .content
        flex 8
        .title
          color $pepperGrey
        .remark
          color $lightGrey
          font-size 0.875rem
        .tag
          margin-top 0.6rem
          text-align left
          height 1.25rem
          line-height 1.25rem
          .creator
            display inline-block
            width 3.4375rem
            display inline-block
            background $lightBlue
            font-size 0.75rem
            color $white
            text-align center
            border-radius 0.375rem
            overflow-x hidden
            margin-right 0.5rem
          .type
            display inline-block
            width 3.4375rem
            overflow-x hidden
            font-size 0.875rem
            color $lightGrey
    // display flex
    // display -webkit-flex
    // .content
    //   flex 5
    // .type
    //   flex 1
    //   text-align center
    //   .icon
    //     margin-left 0.625rem
    //     height 1.8125rem
    //     width  1.8125rem
    //     line-height 1.8125rem
    //     background $blue
    //     border-radius 50%
    //     font-size 0.75rem
    //     color $white
</style>



// WEBPACK FOOTER //
// src/pagesPc/others/scheduleList.vue